export enum TKRoundingMethod {
	HalfRoundUp = 1,
	FavorEmployee = 2,
}
